var initializeLocationsMapBlock = function(block){

	setupMarkerGoogleMaps(block);

}

function setupMarkerGoogleMaps(block){
	
	var mapElement = jQuery('#map');
	var mapProps = {};
	var markers = [];
	var zoom = 5;
	var lat = -89;
	
	if(jQuery(window).width() <= 980) {
		lat = -96;
	}
	
	if(jQuery(window).width() < 900) {
		zoom = 3.5;
	}else if(jQuery(window).width() < 1350) {
		zoom = 4;
	}
	 
	mapProps.markers = [];
	
	if(!mapElement.length) return false;
		
	var map = new google.maps.Map(mapElement[0], {
		center				: {lat: 40, lng: lat},		
		zoom				: zoom,
		mapTypeControl		: false,
		scaleControl		: false,
		streetViewControl	: false,
		rotateControl		: false,
		fullscreenControl	: false,
		styles  			: mapStyles
	});
	
	var markerWidth = 19;
	var markerHeight = 26;

	mapInfo.locations = JSON.parse(mapInfo.locations);	
	
	for(var i=0; i<mapInfo.locations.length; i++) {

		var marker = new google.maps.Marker({
			position	: {lat: mapInfo.locations[i].lat, lng: mapInfo.locations[i].lng},
			icon 		: { 
				url			: '/wp-content/themes/plumbweb-child/_assets/img/icon-map-pin.svg', 
				size		: new google.maps.Size(markerWidth, markerHeight), 
				scaledSize	: new google.maps.Size(markerWidth, markerHeight)
			},
			map			: map
		});
		
		marker.set("id", mapInfo.locations[i].id);
		marker.set("filters", mapInfo.locations[i].filters);
		
		google.maps.event.addListener(marker, 'click', function(){

			var locationID = this.get("id");
			
			loadLocationModalContent(locationID);
			
		});
		
		mapProps.markers.push(marker);
		
	}
	
	jQuery('.locations div.location', block).on("click", function(){
		
		var locationID = jQuery(this).attr("data-id");
		
		loadLocationModalContent(locationID);
		
	});
	
	jQuery(".filters select", block).on("change", function(){
		
		var filters = [];
		var intersection = [];
		
		jQuery(".filters select", block).each(function(){
			
			if(jQuery(this).val()) {
				filters.push(jQuery(this).val());
			}
			
		});
		
		// Show hide locations in list
		jQuery('.locations div.location', block).each(function(){
			
			var location = jQuery(this);
			var locationFilters = location.attr("data-filters");
			
			locationFilters = locationFilters.split(",");
			intersection = filters.filter(element => locationFilters.includes(element));
			
			if(intersection.length >= filters.length) {
				location.removeClass("hide");
			} else {
				location.addClass("hide");
			}
			
		});
		
		// Show hide locations in Google maps
		if(mapProps.markers.length) {
			
			for(var i=0; i<mapProps.markers.length; i++){
				
				var mapPinFilters = mapProps.markers[i].get("filters");
				
				intersection = filters.filter(element => mapPinFilters.includes(element));
				
				if(intersection.length >= filters.length) {
					mapProps.markers[i].setVisible(true);
				} else {
					mapProps.markers[i].setVisible(false);
				}
				
			}
			
			//centerMap(map, mapProps.markers, block);
			
		}
		
	});
	
	//centerMap(map, mapProps.markers);
	
}

function centerMap(map, markers, block){
	
	if(markers.length){
	
		var bounds = new google.maps.LatLngBounds();
		
		for(var i=0; i<markers.length; i++){
			
			if(!markers[i].getVisible()) {
				continue;
			}
			
			bounds.extend({
				lat: markers[i].position.lat(),
				lng: markers[i].position.lng()
			});
			
		}
	
		if(markers.length == 1){
			map.setCenter(bounds.getCenter());
	
		} else{
			map.fitBounds(bounds);
		}
		
		var markerCount = jQuery(".wp-block-locations-map .locations .location:not(.hide)").length;
		
		console.log("count: " + markerCount);
		
		setTimeout(function(){
			if(jQuery(window).width() > 980 && markerCount > 1) {
				map.setZoom(map.getZoom()-1.5);
			}else if(markerCount == 1) {
				map.setZoom(map.getZoom()-12);
			}
		}, 100);
	
	}
	
}

function loadLocationModalContent(locationID) {
	
	jQuery.ajax({
		url:"/wp-admin/admin-ajax.php",
		type:'POST',
		data:'action=load_location_modal_content&location_id='+ locationID,
		success:function(results){
			var modal = jQuery('div[data-remodal-id="location-modal"]');
			jQuery(".content", modal).html(results);
			modal.remodal().open();
		}
	});
	
}

//initialize each block on front end
jQuery(document).ready(function(){
	jQuery('.wp-block-locations-map').each(function(){
		initializeLocationsMapBlock(jQuery(this));
	});
});

//initialize dynamic block preview in the editor
if(window.acf)
	window.acf.addAction('render_block_preview/type=locations-map', initializeLocationsMapBlock);
